import React, { Component } from 'react';
import { connect } from 'react-redux';
import { repositoryState, combineStates, complexSelectorState } from '../../../../store';
import { SelectorViewer, ViewItem } from '..';
import { translate } from '../../../../services';
import { constructTree, getSelectedValue, getAvailableValues, getSelector } from '../../../../util';
import { PropTypes } from 'prop-types';
import { Selection } from '../../../../components';
/* https://jsfiddle.net/Icepickle/jk98umwt/8/ */

const Filter = ( { data, name, onChange, selected, title, variable } ) => {
  const isDefault = () => false;
  const isSelected = item => selected === item.value;
  const isForceable = () => false;
  const change = item => onChange( item, variable.identifier );

  return <Selection 
    groupName={ name } 
    identifier={ variable.identifier }
    isSelected={ isSelected } 
    isDefault={ isDefault }
    isForceable={ isForceable }
    onChange={ change }
    template={ ViewItem }
    title={ title } 
    values={ data }
  />;
};

const getSelectedValues = ( props ) => {
  const { complexSelectors, selector } = props;

  if ( complexSelectors[selector.name] ) {
    const currentSelector = complexSelectors[selector.name].selector.name;
    const configuration = selector.complexSelector.configurations.firstOrDefault( conf => conf.name === currentSelector );
    return configuration && configuration.configurationString && configuration.configurationString.split( '#' );
  }

  return [];
};

export class ComplexSelectorComponent extends Component {
  constructor( ...args ) {
    super( ...args );
    this.state = {
      /* empty state to start with */
    };
  }

  static getDerivedStateFromProps( props, state ) {
    if (props.complexSelectors !== state.complexSelectors || props.selector.complexSelector !== state.complexSelector ) {
      return {
        tree: constructTree( props.selector.complexSelector ) ,
        selectedValues: getSelectedValues( props ),
        complexSelector: props.selector.complexSelector,
        complexSelectors: props.complexSelectors
      };
    }
    return null;
  }

  initComplexSelector( props ) {
    const { selector } = props;

    this.setState( {
      tree: constructTree( selector.complexSelector ) ,
      selectedValues: getSelectedValues( props )
    } );
  }

  variableChanged = ( value, variable ) => {
    let { onSelectorChanged, selector } = this.props;
    let { selectedValues = [], tree } = this.state;
    let key = `${variable}$${value.value}`;
    let newState = [ key ];
    let remainingChoices = Object.keys( tree[key] ).where( key => key !== 'selector' && key !== 'modelToLoad' ).select();
    if ( remainingChoices.length === 1 ) {
      // exactly one choice
      newState.push( remainingChoices[0] );
    } else if ( remainingChoices.length > 1 ) {
      let previousMatches = selectedValues.where( v => !v.startsWith( variable + '$' ) && remainingChoices.indexOf( v ) >= 0 ).select();
      if ( previousMatches.length !== 1 ) {
        newState.push( remainingChoices[0] );
      } else {
        newState.push( previousMatches[0] );
      }
    }

    this.setState( 
      { selectedValues: newState }, 
      () => onSelectorChanged( getSelector( this.state.selectedValues, this.state.tree, this.props.items, this.props.selector.name ), selector ) 
    );
  }


  render() {
    const { items, selector } = this.props;
    if ( !selector ) {
      return null;
    }
    let { complexSelector } = selector;
    let { selectedValues = [], tree } = this.state;
    let selectorViewer = getSelector( selectedValues, tree, items, selector.name ).selector;
    const SelectorViewerComponent = SelectorViewer( selectorViewer.name );
    const complexFilterComponents = complexSelector && complexSelector.variables && complexSelector.variables.map( variable => {
      const translated = translate( variable.identifier );
      const data = getAvailableValues( variable.identifier, tree, complexSelector.variables[0].identifier, selectedValues, ( selectorViewer || selector ).name )
        .map( value => ( { value, title: translate( value ) } ) );
      
      const selected = getSelectedValue( variable.identifier, selectedValues, ( selectorViewer || selector ).name, tree );

      return <Filter
        key={ variable.identifier }
        name={ selector.name } 
        onChange={ this.variableChanged }
        selected={ selected }
        title={ translated } 
        data={ data }
        variable={ variable }
      />;
    } );

    return <SelectorViewerComponent currentSelector={ selectorViewer || selector } complexFilterComponents={ complexFilterComponents } {...this.props}/>;
  }
}

ComplexSelectorComponent.propTypes = {
  complexSelectors: PropTypes.shape( {} ),
  items: PropTypes.arrayOf( PropTypes.object ),
  onSelectorChanged: PropTypes.func.isRequired,
  selector: PropTypes.shape( {
    complexSelector: PropTypes.shape( {
      variables: PropTypes.array
    } ),
    name: PropTypes.string.isRequired
  } )
};

export const ComplexSelector = connect( combineStates( complexSelectorState, repositoryState( 'selector' ) ) )( ComplexSelectorComponent );